<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.5 16C23.5 11.8579 20.1421 8.5 16 8.5C11.8579 8.5 8.5 11.8579 8.5 16C8.5 20.1421 11.8579 23.5 16 23.5C20.1421 23.5 23.5 20.1421 23.5 16ZM16 10.5C19.0376 10.5 21.5 12.9624 21.5 16C21.5 19.0376 19.0376 21.5 16 21.5C12.9624 21.5 10.5 19.0376 10.5 16C10.5 12.9624 12.9624 10.5 16 10.5ZM15.9998 14.6606C16.5902 14.6606 17.0688 14.182 17.0688 13.5915C17.0688 13.0011 16.5902 12.5225 15.9998 12.5225C15.4093 12.5225 14.9307 13.0011 14.9307 13.5915C14.9307 14.182 15.4093 14.6606 15.9998 14.6606ZM14.9307 15.7297V19.4776H17.0688V15.7297H14.9307Z"
        />
    </svg>
</template>
